import { createReducer, on } from '@ngrx/store';

import { IEnko } from '../../shared/models/Enko.model';
import {
    clearEnko,
    clearUpdatePhoneEnko,
    errorEnko,
    errorUpdatePhoneEnko,
    getEnko,
    successEnko,
    successUpdatePhoneEnko,
    updatePhoneEnko,
} from '../actions/enko.actions';

/**
 * * Baja los datos de enko para conexion url
 */
export interface EnkoState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: IEnko;
}

export const EnkoInit: EnkoState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as IEnko,
};

const _enkoReducer = createReducer(
    EnkoInit,
    on(getEnko, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successEnko, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errorEnko, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(clearEnko, state => ({ ...state, ...EnkoInit })),
);

export function EnkoReducer(state: any, action: any) {
    return _enkoReducer(state, action);
}


/**
 * * Actualiza telefono del tendero cuando realiza el cambio en perfil, para enko
 */
export interface EnkoPhoneState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: {
        phone_number?: string;
    };
}

export const EnkoPhoneInit: EnkoPhoneState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {},
};

const _enkoPhoneReducer = createReducer(
    EnkoPhoneInit,
    on(updatePhoneEnko, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successUpdatePhoneEnko, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errorUpdatePhoneEnko, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(clearUpdatePhoneEnko, state => ({ ...state, ...EnkoPhoneInit })),
);

export function EnkoPhoneReducer(state: any, action: any) {
    return _enkoPhoneReducer(state, action);
}
